// src/components/globalBar/GlobalBar.jsx

import React from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import SearchBar from "../searchBars/SearchBar";
import DropdownMenu from "../profileDropDown/dropDown";
import NotificationsDropdown from "../notificationsDropDown/notificationsDropDown";
import MobileSearchOverlay from "../searchBars/MobileSearchOverlay";

import {
  openMobileSearch,
  closeMobileSearch,
} from "../../redux/ui/uiSlice";

const GlobalBar = () => {
  const dispatch = useDispatch();

  // ✅ Single source of truth for mobile search
  const mobileSearchOpen = useSelector(
    (s) => s.ui?.openMobileSearch
  );

  return (
    <>
      {/* NAV BAR */}
      <nav
        aria-label="Global navigation"
        className="
          fixed top-0 left-0 right-0
          bg-white text-gray-900 dark:bg-gray-900 dark:text-white
          flex items-center
          h-16
          z-[9998]
          shadow-md
          px-2 sm:px-4
          w-full
          overflow-visible
        "
      >
        {/* LOGO */}
        <div className="flex items-center flex-none px-2 sm:px-3 md:px-6">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap select-none"
          >
            <img
              src="/StockerLogo.png"
              alt="Stocker Logo"
              className="h-9 md:h-11 w-auto object-contain"
              loading="eager"
            />
          </Link>
        </div>

        {/* DESKTOP SEARCH BAR */}
        <div
          className="
            hidden sm:flex
            flex-1 min-w-0
            px-2 md:px-10
            overflow-visible
          "
        >
          <SearchBar className="w-full min-w-0" />
        </div>

        {/* MOBILE SEARCH BUTTON */}
        <button
          className="
            sm:hidden
            p-2 rounded-lg
            hover:bg-gray-100 dark:hover:bg-gray-800
            ml-auto
            flex-shrink-0
          "
          onClick={() => dispatch(openMobileSearch())}
        >
          <Search className="w-6 h-6 text-gray-500 dark:text-gray-300" />
        </button>

        {/* RIGHT SIDE (DESKTOP ONLY) */}
        <div
          className="
            hidden sm:flex
            items-center
            space-x-4 md:space-x-6
            pr-3 md:pr-6
          "
        >
          <NotificationsDropdown />
          <DropdownMenu />
        </div>
      </nav>

      {/* FULLSCREEN MOBILE SEARCH OVERLAY */}
      {mobileSearchOpen && (
        <MobileSearchOverlay
          onClose={() => dispatch(closeMobileSearch())}
        />
      )}
    </>
  );
};

export default GlobalBar;
